import Link from "next/link"
import { ComponentType, ReactNode } from "react"

type NoContentProps = {
  status?: string
  text?: string
  className?: string
  children?: ReactNode
}

export const NoContent: ComponentType<NoContentProps> = ({
  status = '404',
  text = '',
  className,
  children
}) => (
    <div className={`no-content ${className}`}>
      <h1 className="no-content__status">{status}</h1>
      {status === '404' && <p className="no-content__text">Dieser Artikel existiert leider nicht.</p>}
      {text && <p className="no-content__text">{text}</p>}
      {children && children}
      <Link href="/" className="btn btn-primary">
          Zur Startseite
      </Link>
    </div>
  )
